<template>
  <v-card class="pb-4">
    <v-card-title class="subtitle-1 font-weight-bold"
      >{{ $vuetify.lang.t("$vuetify.users.list.title") }}
    </v-card-title>
    <v-divider></v-divider>
    <div class="mt-5 mx-5">
      <v-btn
        :loading="loading.refresh"
        @click="refreshItems()"
        class="mr-2 my-2"
        depressed
      >
        <v-icon color="primary" left>mdi-refresh</v-icon>
        {{ $vuetify.lang.t("$vuetify.btn.refresh") }}
      </v-btn>
      <template v-if="$auth.check(['ROLE_ADMIN'])">
        <v-btn @click="newUser()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-account-plus-outline</v-icon>
          {{ $vuetify.lang.t("$vuetify.users.btn.new") }}
        </v-btn>
        <v-btn @click="newApp()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-application</v-icon>
          {{ $vuetify.lang.t("$vuetify.users.btn.apps.new.title") }}
        </v-btn>
      </template>
      <v-btn @click="showFilter()" class="my-2" depressed>
        <v-icon color="primary" left>mdi-filter-outline</v-icon>
        {{ $vuetify.lang.t("$vuetify.users.btn.filter.title") }}
      </v-btn>
    </div>
    <v-data-table
      :footer-props="{
        'items-per-page-options': itemPerPageOptions
      }"
      :headers="headers"
      :items="items"
      :items-per-page="itemPerPage"
      :loading="loading.list"
      :options.sync="pagination"
      :server-items-length="meta.total"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      class="mt-5"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            :key="item.id"
            @mouseleave="unSelectItem()"
            @mouseover="selectItem(item)"
            v-for="item in items"
          >
            <td class="subtitle-2">
              {{ $moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </td>
            <td class="subtitle-2">
              <v-chip class="chip-list" color="primary" text-color="white">{{
                item.username
              }}</v-chip>
            </td>
            <td class="subtitle-2">
              <v-chip
                :color="getRoleColor(item.role)"
                class="chip-list"
                text-color="white"
                >{{ $vuetify.lang.t("$vuetify.roles." + item.role) }}
              </v-chip>
            </td>
            <td class="subtitle-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <template v-if="item.enabled">
                    <v-icon
                      :disabled="!$auth.check(['ROLE_ADMIN'])"
                      @click="enabled(item)"
                      class="pointer"
                      color="teal accent-4"
                      dark
                      v-on="on"
                      >mdi-check-circle-outline
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon
                      :disabled="!$auth.check(['ROLE_ADMIN'])"
                      @click="enabled(item)"
                      class="pointer"
                      color="red accent-4"
                      dark
                      v-on="on"
                      >mdi-close-circle-outline
                    </v-icon>
                  </template>
                </template>
                <span v-if="item.enabled">{{
                  $vuetify.lang.t("$vuetify.users.cols.enabled.disable.title")
                }}</span>
                <span v-else>{{
                  $vuetify.lang.t("$vuetify.users.cols.enabled.enable.title")
                }}</span>
              </v-tooltip>
            </td>
            <td class="subtitle-2">
              <v-chip
                :color="item.balance > 0 ? 'teal accent-4' : 'red'"
                class="chip-list"
                text-color="white"
                >{{ item.balance }}
              </v-chip>
            </td>
            <td class="subtitle-2">
              <span v-if="item.lastLogin">{{
                $moment(item.lastLogin).format("YYYY-MM-DD HH:mm:ss")
              }}</span>
              <span v-else>-</span>
            </td>
            <td class="subtitle-2" style="min-width: 200px">
              <template v-if="item === selectedItem">
                <v-tooltip top v-if="$auth.check(['ROLE_ADMIN'])">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="editUser(item)"
                      color="primary"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-account-edit-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.edit.title")
                  }}</span>
                </v-tooltip>
                <v-tooltip
                  top
                  v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMPTA'])"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="newProvision(item)"
                      color="teal accent-4"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-cash</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.provision.new.tooltip")
                  }}</span>
                </v-tooltip>
                <v-tooltip
                  top
                  v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMPTA'])"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="settingsUser(item)"
                      color="secondary"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-account-settings-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.setting.tooltip")
                  }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="
                        $router.push({
                          name: 'application',
                          query: { userId: item.id, username: item.username }
                        })
                      "
                      color="primary"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-apps</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.apps.new.tooltip")
                  }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="showOperation(item)"
                      color="primary"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-history</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.operation.tooltip")
                  }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="viewDetails(item)"
                      color="primary"
                      icon
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t("$vuetify.users.btn.view.title")
                  }}</span>
                </v-tooltip>
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <user-form
      :dialog="dialogForm"
      :form="form"
      @getItems="getItems"
      ref="userForm"
    ></user-form>
    <status-form
      :dialog="dialogForm"
      @getItems="getItems"
      ref="statusForm"
    ></status-form>
    <app-form
      :dialog="dialogForm"
      @getItems="getItems"
      ref="appForm"
    ></app-form>
    <provision-form
      :dialog="dialogForm"
      @getItems="getItems"
      ref="provisionForm"
    ></provision-form>
    <operation-form :dialog="dialogForm" ref="operationForm"></operation-form>
    <detail-form :dialog="dialogForm" ref="detailForm"></detail-form>
    <filter-form
      :dialog="dialogForm"
      :filter="filter"
      @performFilter="performFilter"
      ref="filterForm"
    ></filter-form>
    <settings-form
      :dialog="dialogForm"
      @getItems="getItems"
      ref="settingForm"
    ></settings-form>
  </v-card>
</template>

<script>
import ListMixin from "./../../mixins/Common/List.vue";
import UserForm from "./Form";
import FilterForm from "./Filter";
import AppForm from "../application/Form";
import ProvisionForm from "../provision/Form";
import StatusForm from "./StatusForm";
import OperationForm from "./OperationForm";
import SettingsForm from "./Settings";
import DetailForm from "./Detail";
import CONSTANTS from "../../helpers/Constants";

export default {
  mixins: [ListMixin],
  data: () => ({
    urlItems: "/users",
    sortBy: ["u_id"],
    dialogForm: {
      title: "$vuetify.users.new.title",
      shows: {
        showUser: false,
        showApp: false,
        showProvision: false,
        showOperation: false,
        showFilter: false,
        showInfo: false,
        showSetting: false,
        showDetail: false
      },
      saveBtnTitle: "$vuetify.btn.save",
      action: "create"
    },
    form: CONSTANTS.defaultUserForm(),
    filter: {
      username: null,
      code: null,
      role: null,
      fullName: null,
      phone: null,
      email: null,
      address: null
    }
  }),
  created() {
    this._search = this.buildSearchQuery();
  },
  methods: {
    setHeaders() {
      this.headers = [
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.created.title"),
          value: "u_createdAt",
          align: "start",
          sortable: true,
          width: "138",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.username.title2"),
          value: "u_username",
          align: "start",
          sortable: true,
          width: "140",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.role.title2"),
          value: "u_role",
          align: "start",
          sortable: true,
          width: "120",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.enabled.title"),
          value: "u_enabled",
          align: "start",
          sortable: true,
          width: "80",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.balance.title"),
          value: "u_balance",
          align: "start",
          sortable: true,
          width: "110",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.last_login.title"),
          value: "u_lastLogin",
          align: "start",
          sortable: false,
          width: "140",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.users.cols.action.title"),
          value: null,
          sortable: false,
          width: "200"
        }
      ];
    },
    newUser() {
      this.form = CONSTANTS.defaultUserForm();
      this.$refs.userForm.resetForm();
      this.dialogForm.title = this.$vuetify.lang.t("$vuetify.users.new.title");
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
      this.dialogForm.shows.showUser = true;
      this.dialogForm.action = "create";
    },
    editUser(user) {
      this.$refs.userForm.setForm(user);
      this.dialogForm.title = this.$vuetify.lang.t("$vuetify.users.edit.title");
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.edit");
      this.dialogForm.shows.showUser = true;
      this.dialogForm.action = "edit";
    },
    enabled(user) {
      this.$refs.statusForm.setForm(user);
      if (!user.enabled) {
        this.dialogForm.title = this.$vuetify.lang.t(
          "$vuetify.users.cols.enabled.enable.message"
        );
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t(
          "$vuetify.btn.edit"
        );
        this.dialogForm.shows.showInfo = true;
      } else {
        this.dialogForm.title = this.$vuetify.lang.t(
          "$vuetify.users.cols.enabled.disable.message"
        );
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t(
          "$vuetify.btn.edit"
        );
        this.dialogForm.shows.showInfo = true;
      }
    },
    newApp() {
      this.form = CONSTANTS.defaultAppForm();
      this.$refs.appForm.resetForm();
      this.dialogForm.action = "user";
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.users.btn.apps.new.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
      this.dialogForm.shows.showApp = true;
    },
    newProvision(user) {
      this.form = CONSTANTS.defaultProvisionForm();
      this.$refs.provisionForm.resetForm();
      this.$refs.provisionForm.setForm(user);
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.users.btn.provision.new.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
      this.dialogForm.shows.showProvision = true;
      this.dialogForm.action = "create";
    },
    showOperation(user) {
      this.$refs.operationForm.setUser(user);
      this.dialogForm.shows.showOperation = true;
    },
    showFilter() {
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.users.filter.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t(
        "$vuetify.users.btn.filter.title"
      );
      this.dialogForm.shows.showFilter = true;
    },
    settingsUser(user) {
      this.$refs.settingForm.setForm(user);
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.users.setting.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.edit");
      this.dialogForm.shows.showSetting = true;
      this.dialogForm.action = "edit";
    },
    buildSearchQuery() {
      let query = "";
      if (this.filter.username) {
        if (this._.isEmpty(query))
          query = "u_username::iLike::%" + this.filter.username + "%";
        else query += ",u_username::iLike::%" + this.filter.username + "%";
      }
      if (this.filter.code) {
        if (this._.isEmpty(query))
          query = "u_code::iLike::%" + this.filter.code + "%";
        else query += ",u_code::iLike::%" + this.filter.code + "%";
      }
      if (this.filter.role) {
        if (this._.isEmpty(query)) query = "u_role::eq::" + this.filter.role;
        else query += ",u_role::eq::" + this.filter.role;
      }
      if (this.filter.fullName) {
        if (this._.isEmpty(query))
          query = "u_fullname::iLike::%" + this.filter.fullName + "%";
        else query += ",u_fullname::iLike::%" + this.filter.fullName + "%";
      }
      if (this.filter.phone) {
        if (this._.isEmpty(query))
          query = "u_phone::iLike::%" + this.filter.phone + "%";
        else query += ",u_phone::iLike::%" + this.filter.phone + "%";
      }
      if (this.filter.email) {
        if (this._.isEmpty(query))
          query = "u_email::iLike::%" + this.filter.email + "%";
        else query += ",u_email::iLike::%" + this.filter.email + "%";
      }
      if (this.filter.address) {
        if (this._.isEmpty(query))
          query = "u_address::iLike::%" + this.filter.address + "%";
        else query += ",u_address::iLike::%" + this.filter.address + "%";
      }
      if (this._.isEmpty(query)) query = null;
      return query;
    },
    performFilter() {
      this._search = this.buildSearchQuery();
      let self = this;
      this.getItems()
        .then(() => {
          this.$refs.filterForm.closeDialog();
        })
        .finally(() => {
          self.$refs.filterForm.stopLoadingBtn();
        });
    },
    getRoleColor(role) {
      switch (role) {
        case "ROLE_ADMIN":
          return "teal accent-4";
        case "ROLE_COMPTA":
          return "teal accent-3";
        case "ROLE_COMMERCIAL":
          return "secondary";
        default:
          return "orange accent-4";
      }
    },
    viewDetails(item) {
      this.$refs.detailForm.setForm(item);
      this.dialogForm.title = this.$vuetify.lang.t("$vuetify.users.view.title");
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
      this.dialogForm.shows.showDetail = true;
    }
  },
  components: {
    UserForm,
    ProvisionForm,
    StatusForm,
    OperationForm,
    FilterForm,
    DetailForm,
    SettingsForm,
    AppForm
  }
};
</script>
